export enum RegularOrdersAssignJobCommandValue {
  ASSIGN_COMMAND = "assign",
  UNASSIGN_COMMAND = "unassign",
}
